import { mdiFormatTitle } from '@lumapps/lumx/icons';

export const WIDGET_TITLE_TYPE = 'title';

export const CLASSNAME = 'widget-title';

export const EDITION_TITLE_TEXTAREA_CLASSNAME = 'editable-textarea';

export const WIDGET_TITLE_ICON = mdiFormatTitle;
